import { useEffect, useState } from 'react';
import { Table, Card, Input, Select, Button, message, Typography, Space, Popconfirm, Tag } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;

export default function GovServicesPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState(null);
  const [types, setTypes] = useState([]);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      if (typeFilter) params.type = typeFilter;
      const r = await api.get('/admingov/services', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(1);
    api.get('/admingov/service-types').then(r => setTypes(r.data.data)).catch(() => {});
  }, []);
  useEffect(() => { fetchData(1); }, [search, typeFilter]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/services/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Nomi', dataIndex: 'name' },
    { title: 'Turi', dataIndex: 'type_name', render: v => <Tag color="blue">{v}</Tag> },
    { title: 'Biznes', dataIndex: 'business_name' },
    { title: 'Viloyat', dataIndex: 'region' },
    { title: 'Manzil', dataIndex: 'address' },
    {
      title: 'Amal', width: 60,
      render: (_, r) => (
        <Popconfirm title="O'chirish?" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Title level={3}>Xizmatlar boshqaruvi</Title>
      <Card style={{ borderRadius: 12, marginBottom: 16 }}>
        <Space wrap>
          <Input placeholder="Nomi" prefix={<SearchOutlined />} allowClear value={search} onChange={e => setSearch(e.target.value)} style={{ width: 250 }} />
          <Select placeholder="Xizmat turi" allowClear style={{ width: 200 }} value={typeFilter} onChange={setTypeFilter}
            options={types.map(t => ({ label: t.name, value: t.id }))} />
        </Space>
      </Card>
      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={data} columns={columns} rowKey="id" loading={loading} size="small" scroll={{ x: 700 }}
          pagination={{ current: page, total, pageSize: 20, onChange: p => { setPage(p); fetchData(p); } }}
        />
      </Card>
    </div>
  );
}
